import { render, staticRenderFns } from "./MaterialsSettings.vue?vue&type=template&id=4da0dc4a&scoped=true"
import script from "./MaterialsSettings.vue?vue&type=script&lang=js"
export * from "./MaterialsSettings.vue?vue&type=script&lang=js"
import style0 from "./MaterialsSettings.vue?vue&type=style&index=0&id=4da0dc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0dc4a",
  null
  
)

export default component.exports